/*
 
Skórki Material

 
*/

import * as M from '@material-ui/core';
import { createStyles } from '@material-ui/styles';

//import './theme.css'

// https://in-your-saas.github.io/material-ui-theme-editor/
// http://mcg.mbitson.com/#!?mcgpalette0=%2338920a&mcgpalette2=%2326a69a&themename=rez1
// https://www.materialpalette.com/blue/lime

//https://material-ui.com/style/color/

// material

// po wpisaniu do pliku:
import themeProject from './cfg/theme.json';

let appPalette = themeProject.palette

const themeDialog = M.createTheme({
  //  palette: appPalette,
  palette: {
    primary: { main: "#458B00" },  //  "#458B00"
    secondary: { main: "#c00", dark: "#c00" },    //#3a87ad  //#005a7e //#b63b4d
    error: { main: "rgb(244, 67, 54)" },
    text: { primary: "rgba(0, 0, 0, 0.87)", secondary: "#555" }
  },
  typography: {
    fontSize: 10,
    //fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol"`,
    h6: {
      fontWeight: "normal"
    },
    subtitle2: {
      fontWeight: "normal"
    }
    /*?? */
    //   useNextVariants: true,  
  },
  overrides: {
    MuiFormHelperText: {
      root: {
        fontSize: "0.75rem"
      }
    },
    MuiButton: {
      contained: {
        padding: "5px 16px"
      },
      outlined: {
        padding: "4px 16px"
      }

    },
    MuiLink: {
      underlineHover: {
        "&:hover": {
          textDecoration: "none",
          color: "#7c848a"
        }
      },
      root: {

        padding: "22px",
        fontWeight: 600,
        fontSize: "0.8rem",
        display: "inline-block",
        cursor: "pointer",
        textTransform: "uppercase"
      }
    },
    MuiTableCell: {
      root: {
        padding: "3px 10px 3px 3px",
        borderBottom: "0",
        fontSize: "0.675rem"
      },
      body: {
        color: "rgb(0, 96, 16)"
      },
      head: {
        color: "#c00",
        fontSize: "0.9rem"
      }
    },
    MuiOutlinedInput: {
      input: {
        padding: "8px 14px",
        textAlign: "center",
        fontWeight: "bold"
      },
      multiline: {
        padding: "0px"
      }
    },
    MuiSelect: {
      selectMenu: {
        fontWeight: 'bold',
        textAlign: "left" as "left"
      },
      icon: {
        fontSize: "1.5rem"
      }
    },
    MuiMenuItem:{
      root:{
        fontSize: "1rem"
      }
    }
  }
}
)

/*
const styleAppBar = (theme : any) => ({
  root: {
    width: '100%',
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  title: {
    display: 'none',
    [theme.breakpoints.up('sm')]: {
      display: 'block',
    },
  }
})  
  
styleAppBar,
*/

/*const styles = createStyles(appPalette);

export { styles,  appPalette }
*/
export default themeDialog



